import {Composition} from 'remotion';
import {InteractiveDashboard} from './InteractiveDashboard';
import {VIDEO, WorkTimeline} from './WorkTimeline';

export const RemotionRoot = () => {
  return (
    <>
      <Composition
        id="WorkTimeline"
        component={WorkTimeline}
        durationInFrames={VIDEO.durationInFrames}
        fps={VIDEO.fps}
        width={VIDEO.width}
        height={VIDEO.height}
      />
      <Composition
        id="InteractiveDashboard"
        component={InteractiveDashboard}
        durationInFrames={VIDEO.durationInFrames}
        fps={VIDEO.fps}
        width={VIDEO.width}
        height={VIDEO.height}
      />
    </>
  );
};
